import { useState, useMemo, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import * as actions from '@actions'

import CircleSpinner from '@components/shared/CircleSpinner'

const CheckPreview = () => {
    
    const { checkId, pageIndex } = useParams()
    
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [check, setCheck] = useState()
    const [imageUrl, setImageUrl] = useState('')
    
    const pageFileName = useMemo(() => (
        check?.pages?.[pageIndex || 0]?.fileName ?? null
    ), [check])
    
    useEffect(() => {
        
        if (!checkId) return
        
        setLoading(true)
        
        actions.fetchCheckById(checkId)
            .then(it => {
                console.log('fetched check', it)
                setCheck(it)
            })
            .catch(e => {
                console.error('fetch check', e)
                setError('Failed to fetch check')
            })
            .finally(() => setLoading(false))
        
    }, [checkId])
    
    useEffect(() => {
        
        if (!pageFileName?.length) return
        
        setLoading(true)
        
        actions.streamFileUrl(pageFileName)
            .then(it => setImageUrl(URL.createObjectURL(it)))
            .catch(e => {
                console.error('stream check page image', e)
                setError('Failed to load check image')
            })
            .finally(() => setLoading(false))
        
    }, [pageFileName])
    
    if (error) return (
        <div className="CheckPreview">
            <div className="absolute-centered">
                {error}
            </div>
        </div>
    )
    
    if (loading) return (
        <div className="CheckPreview">
            <CircleSpinner className="absolute-centered" />
        </div>
    )
    
    if (!checkId) return (
        <div className="CheckPreview">
            <div className="absolute-centered">
                Check not found
            </div>
        </div>
    )
    
    return (
        
        <div className="CheckPreview">
            
            <img
                width="100%"
                height="100%"
                src={imageUrl} />
        
        </div>
        
    )
    
}

export default CheckPreview
